<template>
    <div class="sales-order">
        <div class="order-main">
            <el-table :data="salesOrder" border>
                <el-table-column label='序号' align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{ scope.$index + ( page - 1 ) * pageSize + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label='订单号' prop='supplier_order_code' align="center"></el-table-column>
                <el-table-column label='客户' prop='name' align="center"></el-table-column>
                <el-table-column label='项目地址' prop='address' align="center"></el-table-column>
                <el-table-column label='交货日期' prop="delivery_time" align="center"></el-table-column>
                <el-table-column label='Bom料单' prop="matterials" align="center" width="90">
                    <template slot-scope="scope">
                        <span @click="gotoMaterials(scope.row)">料单</span>
                    </template>
                </el-table-column>
                <el-table-column label='仓库状态' prop="warehouse_status" align="center">
                    <template>
                        <span>———</span>
                    </template>
                </el-table-column>
                <el-table-column label='订单状态' prop="status_mark" align="center">
                    <template slot-scope="scope">
                        <span v-for="(item, index) in status_menu" :key="index">
                            <el-popover placement="bottom" trigger="click" ref="popover">
                                <div class="sale-change-box">
                                    <span class="all-sale-status" v-for="status_item in status_menu" :key="status_item.id" @click="changeSaleOrderStatus(scope.row, status_item.id, index)">{{status_item.name}}</span>
                                </div>
                                <span slot="reference" v-if="scope.row.status_mark == item.id && scope.row.status_mark != 0">{{item.name}}</span>
                            </el-popover>
                            <span v-if="scope.row.status_mark == item.id && scope.row.status_mark == 0" @click="remind">{{item.name}}</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label='生产批号' prop="produce_order" align="center"></el-table-column>
                <el-table-column label='车间进度' prop="workshop_schedule" align="center">
                    <!-- <template slot-scope="scope">
                        <div class="process-box">
                            <div class="process_finish" :style="`width: ${scope.row.schedule ? scope.row.schedule.length * 20 : 0}%`"></div>
                        </div>
                    </template> -->
                </el-table-column>
                <el-table-column label='包装数量' prop="pack_num" align="center"></el-table-column>
                <el-table-column label='物流信息' prop="logistics" align="center"></el-table-column>
                <el-table-column label='面积(m²)' prop="area" align="center"></el-table-column>
                <el-table-column label='金额(元)' prop="final_cost" align="center"></el-table-column>
                <el-table-column label='已收款' prop="paid" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.balance.paid}}</span>
                    </template>
                </el-table-column>
                <el-table-column label='余款' prop="unpaid" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.balance.unpaid}}</span>
                    </template>
                </el-table-column>
                <el-table-column label='备注' prop="reamrk" align="center"></el-table-column>
                <el-table-column label='录单员' prop="staff_name" align="center"></el-table-column>
                <el-table-column label='业务员' prop="" align="center"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { orderSet } from 'gweb_common'
export default {
    props: {
        orderList: {
            type: [Array, Object],
            default: () => []
        },
        page: {
            type: Number,
            default: 1
        },
        getOrderList: {
            type: Function,
            default: function(){}
        }
    },
    data(){
        return{
            // 显示转移订单
            show_change_order: false,
            pageSize: 12,
            total_counts: 1,
            status_menu: [
                {
                    name: '未受理',
                    id: 0
                },
                {
                    name: '待收款',
                    id: 1
                },
                {
                    name: '未付清',
                    id: 2
                },
                {
                    name: '已付清',
                    id: 3
                },
                {
                    name: '在生产',
                    id: 4
                },
                {
                    name: '待发货',
                    id: 5
                },
                {
                    name: '欠货',
                    id: 6
                },
                {
                    name: '已发货',
                    id: 7
                },
                {
                    name: '待退款',
                    id: 8
                },
                {
                    name: '已退款',
                    id: 9
                },
                {
                    name: '草稿箱',
                    id: 10
                },
            ]
        }
    },
    computed:{
        salesOrder(){
            return this.orderList
        },
    },
    methods: {
        // 点击弹出修改订单状态
        showOrderStatus(row){
            console.log(row)
        },
        // 未受理之前不能改变订单状态
        remind(){
            this.$message({
                message: '暂未受理此订单, 请先受理再进行订单状态转移!',
                duration: 1500,
                offset: 65
            })
        },
        // 改变订单状态
        changeSaleOrderStatus(row, id, index){
            this.$post("/py/erp/update_order_status",{
                status: id,
                id: row.id
            },res => {
                // console.log('订单状态转移',res)
                this.$message({
                    message:'转移成功！',
                    duration:'1500',
                    type: 'success',
                    offset: 65
                });
                this.getOrderList();
            })
        },
    },
    mounted(){}
}
</script>

<style scoped lang="less">
.sales-order{
    .order-main{
        max-height: 700px;
        overflow-y: hidden;
    }
}
.sale-change-box{
    width: 270px;
    .all-sale-status{
        width: 70px;
        height: 30px;
        line-height: 30px;
        display: inline-block;
        margin: 10px 10px;
        padding: 0 5px;
        box-sizing: border-box;
        text-align: center;
        border: 1px solid #000;
        border-radius: 5px;
        cursor: pointer;
    }
}

</style>